import React from 'react';
import { Sparkles, Twitter, Instagram, Youtube, Facebook } from 'lucide-react';
import { useLang } from '../context/LangContext';

const Footer = () => {
  const { t, lang } = useLang();

  const cols = [
    { title: t.footer.product, items: lang === 'sv' ? ['Videoredigerare','AI-verktyg','Mallar','Ladda ner','Nyheter'] : ['محرر فيديو','أدوات الذكاء','قوالب','تنزيل','جديد'] },
    { title: t.footer.resources, items: lang === 'sv' ? ['Handledningar','Blogg','Skaparhubb','Community','Trender'] : ['دروس','مدونة','مركز المبدعين','مجتمع','الرائج'] },
    { title: t.footer.company, items: lang === 'sv' ? ['Om oss','Karriär','Kontakt','Press','Partner'] : ['عنّا','وظائف','تواصل','الصحافة','شركاء'] },
    { title: t.footer.support, items: lang === 'sv' ? ['Hjälpcenter','Kontakta oss','Vanliga frågor','Status','Rapportera'] : ['مركز المساعدة','تواصل معنا','أسئلة','الحالة','إبلاغ'] }
  ];

  return (
    <footer className="bg-neutral-950 text-neutral-300 pt-20 pb-8">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 mb-14">
          <div className="col-span-2">
            <a href="#" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-black" strokeWidth={2.5} />
              </div>
              <span className="font-black text-xl text-white">CapCute</span>
            </a>
            <p className="text-[14px] text-neutral-400 max-w-xs leading-relaxed">{t.footer.tagline}</p>
            <div className="flex items-center gap-2 mt-6">
              {[Twitter, Instagram, Youtube, Facebook].map((Ic, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors" aria-label="social">
                  <Ic className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
          {cols.map((c, i) => (
            <div key={i}>
              <h4 className="text-[13px] font-bold text-white uppercase tracking-wider mb-4">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.items.map((it, j) => (
                  <li key={j}><a href="#" className="text-[13.5px] text-neutral-400 hover:text-white transition-colors">{it}</a></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[12.5px] text-neutral-500">© 2025 CapCute. {t.footer.rights}</p>
          <div className="flex items-center gap-5 text-[12.5px] text-neutral-500">
            <a href="#" className="hover:text-white transition-colors">Privacy</a>
            <a href="#" className="hover:text-white transition-colors">Terms</a>
            <a href="#" className="hover:text-white transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
